export default __webpack_public_path__ + "static/media/not_found.ffd9543f.svg";